import { Flex } from "antd";
import { ReactNode, useState } from "react";

import instructionAndroid from "@/assets/videos/webview-instruction-android.mp4";
import instructionIOS from "@/assets/videos/webview-instruction-ios.mp4";
import BaseButton from "@/components/BaseButton";
import { BaseModal } from "@/components/BaseModal";
import { MainContainer } from "@/components/Layout/Styled";
import { PrimaryText } from "@/components/Typography/Styled";
import { AppIdentity } from "@/components/UI/AppIdentity";
import { ENVIRONMENT } from "@/config";
import { useInAppBrowser } from "@/hooks/useInAppBrowser";

import { StyledImgWrapper } from "./Styled";

export const InAppBlocker = ({ children }: { children: ReactNode }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { isInApp, platform } = useInAppBrowser();

    const instruction =
        platform === "ios" ? instructionIOS : instructionAndroid;

    const browserLabel =
        platform === "ios" ? " Safari або Google Chrome" : " Google Chrome";

    if (isInApp && platform && ENVIRONMENT !== "dev-local") {
        return (
            <>
                <MainContainer>
                    <Flex
                        vertical
                        gap={32}
                        flex={1}
                        style={{ overflow: "hidden" }}
                        align="center"
                        justify="center"
                    >
                        <AppIdentity logoHeight={200} />

                        <PrimaryText
                            fontSize={18}
                            fontWeight="500"
                            textAlign="center"
                        >
                            Відкрито у вбудованому браузері
                        </PrimaryText>

                        <PrimaryText fontSize={16} textAlign="center">
                            Для продовження роботи відкрийте застосунок в
                            {browserLabel}
                        </PrimaryText>

                        <BaseButton
                            type="primary"
                            onClick={() => setIsModalOpen(true)}
                        >
                            Інструкція
                        </BaseButton>
                    </Flex>
                </MainContainer>

                <BaseModal
                    open={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    title={"Інструкція"}
                    maskClosable
                    actions={null}
                    styles={{ content: { height: "95vh" } }}
                >
                    <StyledImgWrapper>
                        <video
                            src={instruction}
                            width={200}
                            height={400}
                            autoPlay
                            loop
                            muted
                            playsInline
                        />
                    </StyledImgWrapper>
                </BaseModal>
            </>
        );
    }

    return <>{children}</>;
};
